import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";

const GLYPH_SIZE = 20;

type Props = {
	children: ReactNode;
};

export const DashboardRowGlyph: FC<Props> = ({ children }) => (
	<Box
		display="inline-flex"
		sx={{
			"& svg": { width: GLYPH_SIZE, height: GLYPH_SIZE },
		}}
	>
		{children}
	</Box>
);
